<p-tabView
  [activeIndex]="activeSubComponent"
  (onChange)="onTabActivated($event)"
  styleClass="bfx-tabview"
>
  <p-tabPanel header="Preferences" styleClass="user-settings-tab-panel">
    <div
      class="user-settings-component-container"
      [style.min-height.px]="panelHeight"
      (blur)="onFocusOut($event)"
    >
      <div *ngIf="ready" class="user-settings-component-container">
        <div class="user-settings-form-field-row" *ngIf="isTrader">
          <div class="user-settings-control control-label">Default Portfolio</div>
          <div class="user-settings-control right">
            <bfx-autoComplete
              #portfolioSelection
              appendTo="body"
              size="sm"
              [(ngModel)]="portfolio"
              [suggestions]="portfolioSuggestions"
              (completeMethod)="searchPortfolio($event)"
              [dropdown]="true"
              (onBlur)="onBlurAutocomplete(portfolioSelection)"
              (onKeyUp)="dataChanged = true"
              (onClear)="dataChanged = true"
              (onSelect)="onSelectPortfolio($event)"
              (onFocus)="$event.target.select()"
              field="label"
              dataKey="value"
              [minLength]="0"
              [dataChanged]="dataChanged"
              (onStateChanged)="portfolioStateChange($event)"
              [emptyIsInactive]="true"
              [maxlength]="50"
              [allowEmptySelection]="true"
              placeholder="-"
            ></bfx-autoComplete>
          </div>
        </div>
        <div class="user-settings-form-field-row">
          <div class="user-settings-control control-label">Language</div>
          <div class="user-settings-control right">
            <bfx-autoComplete
              #languageSelection
              appendTo="body"
              size="sm"
              [disabled]="languageSuggestions.length==1"
              [(ngModel)]="language"
              [suggestions]="languageSuggestions"
              (completeMethod)="searchLanguage($event)"
              (onBlur)="onBlurAutocomplete(languageSelection)"
              [dropdown]="true"
              field="label"
              dataKey="value"
              [maxlength]="50"
              [settingsCorrection]="true"
            ></bfx-autoComplete>
          </div>
        </div>
        <div class="user-settings-form-field-row">
          <div class="user-settings-control control-label">Select Theme</div>
          <div class="user-settings-control right">
            <bfx-autoComplete
              #themeSelection
              size="sm"
              appendTo="body"
              [(ngModel)]="theme"
              [disabled]="hmr"
              [suggestions]="filteredTheme"
              (completeMethod)="filterTheme($event)"
              [minLength]="1"
              placeholder="Select a theme"
              [dropdown]="true"
              (onKeyUp)="dataChanged = true"
              (onClear)="dataChanged = true;"
              (onSelect)="onSelectTheme($event)"
              (onBlur)="onBlurAutocomplete(themeSelection)"
              (onFocus)="$event.target.select()"
              [dataChanged]="dataChanged"
              [autoHighlight]="true"
              field="label"
              dataKey="value"
              (onStateChanged)="themeStateChange($event)"
              [settingsCorrection]="true"
              [title]="hmr ? 'Theme selection locked by HMR Mode' : ''"
            >
            </bfx-autoComplete>
          </div>
        </div>
        <div class="user-settings-form-field-row" *ngIf="nativeDesktop">
          <div class="user-settings-control control-label">Font Size</div>
          <div class="user-settings-control right">
            <bfx-autoComplete
              #fontSizeSelection
              appendTo="body"
              size="sm"
              [(ngModel)]="fontSize"
              [readonly]="true"
              [suggestions]="fontSizes"
              (completeMethod)="searchFontSize($event)"
              [dropdown]="true"
              [autoHighlight]="false"
              delay="4"
              [skipSorting]="true"
              field="label"
              dataKey="value"
              [maxlength]="50"
              (onSelect)="onSelectFontSize($event)"
              (onBlur)="onBlurAutocomplete(fontSizeSelection)"
              (onFocus)="$event.target.select()"
              [dataChanged]="dataChanged"
            ></bfx-autoComplete>
          </div>
        </div>

        <div class="user-settings-control-row" fxLayout="row">
          <div class="row-content" fxflex="80%">
            <span class="user-settings-control-row_title">Save Profile on Logout</span>
            <p class="user-settings-control-row_description">
              All current views and layouts will be restored automatically when you log in again
            </p>
          </div>
          <div fxFlex="20%" class="setting_toggle">
            <bfx-toggle [(ngModel)]="saveProfileOnLogout" (change)="onSaveOnLogoutChange($event)">
            </bfx-toggle>
          </div>
        </div>

        <div *ngIf="changePasswordAvailable" class="user-settings-control control-button">
          <button class="bfx-button-primary" (click)="openChangePassword()">Change Password</button>
        </div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
